import { Box, Grid } from "@material-ui/core";
import React, { useState } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import PrimaryButton from "../../../../ui/components/PrimaryButton";
import { LARGE_SPACING, SMALL_SPACING } from "../../../../ui/theme/dimensions";
import EditableFieldLabel from "../../../properties/PropertyDetailPage/components/EditableField/components/EditableFieldLabel";
import BenchmarkAccount from "../model/BenchmarkAccount";
import UnlinkBenchmarkAccountPopup from "./UnlinkBenchmarkAccountPopup";

interface Props extends WithTranslation {
  loading?: boolean;
  onBenchmarkAction?: (action: BenchmarkAccount) => void;
  isLinked?: boolean;
}

const BENCHMARK_LOGIN_URL = process.env.REACT_APP_BENCHMARK_LOGIN_URL;
const CALLBACK_URL = `${window.location.origin}/benchmark`; 

const BenchmarkAccountPanel: React.FC<Props> = ({
  t,
  loading,
  onBenchmarkAction,
  isLinked,
}) => {
  const [unlinkOpen, setUnlinkOpen] = useState(false);

  const title = t("benchmarkAccountPanel.title");
  const linkLabel = t("benchmarkAccountPanel.linkButtonLabel");
  const unlinkLabel = t("benchmarkAccountPanel.unlinkButtonLabel");
  const linkedLabel = t("benchmarkAccountPanel.linkedLabel");

  const handleLink = () => {
    const benchmarkUrl = `${BENCHMARK_LOGIN_URL}?callback_url=${encodeURIComponent(CALLBACK_URL)}`;
    window.location.href = benchmarkUrl;
  };

  const handleUnlink = () => setUnlinkOpen(true);

  const handleConfirmUnlink = () => {
    setUnlinkOpen(false);
    onBenchmarkAction?.({ type: "unlink" });
  };

  return (
    <Box paddingX={LARGE_SPACING}>
      <Grid container direction="column" spacing={SMALL_SPACING}>
        <Grid item>
          <EditableFieldLabel label={title} />
        </Grid>
        <Grid item>
          <PrimaryButton
            fullWidth
            label={isLinked ? linkedLabel : linkLabel}
            isLoading={loading}
            onClick={isLinked ? undefined : handleLink}
            variant={isLinked ? "contained" : "outlined"}
            colour={isLinked ? "primary" : "secondary"}
            disabled={!!isLinked}
          />
        </Grid>
        <Grid item>
          <PrimaryButton
            fullWidth
            label={unlinkLabel}
            isLoading={loading}
            onClick={handleUnlink}
            variant="outlined"
            colour={isLinked ? "secondary" : "default"}
            disabled={!isLinked}
          />
        </Grid>
      </Grid>

      <UnlinkBenchmarkAccountPopup
        open={unlinkOpen}
        onCancel={() => setUnlinkOpen(false)}
        onUnlink={handleConfirmUnlink}
      />
    </Box>
  );
};

export default withTranslation()(BenchmarkAccountPanel);